<template>
  <v-content>
    <v-alert
      v-if="shouldShow"
      :color="'warning'"
      :class="$route.name == 'Login' ? 'block-login' : ''"
      v-model="alert"
      transition="scale-transition"
    >
      Prezado Corretor, o horário de funcionamento do Portal do Corretor JNS é
      das 07:15 às 23:55 horas!
      <slot />
    </v-alert>
  </v-content>
</template>

<script lang="js">
export default {
  name: "FormAlertFullBlock",
  data: () => ({
    alert: true,
    fadeAwayInterval: false,
    timeInterval: 60 * 1000,
  }),
  computed: {
    shouldShow() {
      return true;
    },
  },

  props: {
    source: String,
    message: String,
    type: String,
  },
  
  updated() {
    if (this.shouldShow) {
      this.fadeAwayInterval = setTimeout(() => {
        this.closeButton();
      }, this.timeInterval);
    }
  },
  destroyed() {},
  methods: {
    closeButton() {
      let t = this;
      setTimeout(() => {
        clearInterval(this.fadeAwayInterval);
        t.$emit("close");
        t.alert = true;
      }, 500);
    },
  },
  watch: {
    alert: (val, oldVal) => {},
  },
};
</script>

<style lang="scss" scoped>
#jns {
  .block-login {
    background-clip: padding-box;
    border-bottom: 50vh solid rgba(0, 0, 0, 0.87) !important;
    border-top: 50vh solid rgba(0, 0, 0, 0.87) !important;
    padding: 5vh 0;
    font-size: 2vh;
    background-color: #061d45 !important;
  }

  .v-alert {
    position: fixed;
    width: -webkit-fill-available;
    z-index: 51;
    border-radius: 4px;
    text-align: center;
    top: -5px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/FormAlertFullBlock.vue